/** User-facing messages for team API error codes. */
const TEAM_ERROR_MESSAGES = {
  duplicate_invite: "A pending invite already exists for this email.",
  email_already_registered: "This email is already registered. Ask them to sign in instead.",
  invalid_role: "Only Admin or Member roles can be invited.",
  plan_required: "Upgrade to Founder plan or above to invite teammates.",
  insufficient_role: "You don't have permission to perform this action.",
  cannot_self_demote: "Owners cannot change their own role. Transfer ownership first.",
  last_owner: "This workspace must keep at least one owner.",
  cannot_self_remove: "Use Account settings to delete your own account.",
  invite_unusable: "This invitation is no longer valid.",
  invite_not_found: "Invitation not found.",
  member_not_found: "Team member not found.",
  no_tenant: "No workspace is selected for this account.",
};

export function teamErrorMessage(err, fallback = "Something went wrong. Please try again.") {
  if (err?.code && TEAM_ERROR_MESSAGES[err.code]) return TEAM_ERROR_MESSAGES[err.code];
  return err?.message || fallback;
}

export function formatRoleLabel(role) {
  const labels = {
    owner: "Owner",
    admin: "Admin",
    member: "Member",
    viewer: "Viewer",
  };
  return labels[role] || role;
}

export function formatJoinDate(iso) {
  if (!iso) return "—";
  try {
    return new Date(iso).toLocaleDateString(undefined, {
      month: "short",
      day: "numeric",
      year: "numeric",
    });
  } catch {
    return "—";
  }
}
